import React, { Component } from 'react'
import { connect } from 'react-redux'

import GoogleLogin from 'react-google-login'
import ReactLoginMS from 'react-ms-login'

import { oneClickSignon,
  postAddAgendas,
  outlookAuth,
  iCloudAuth } from '../../../../api/api'

import Loading from '../../../../Components/loading/Loading'

import googleWithoutText from '../../../../assets/img/googleWithoutText.png'
import officeWithoutText from '../../../../assets/img/officeWithoutText.png'
import exchangeLogo from '../../../../assets/img/exchange.jpg'
import icloudWithoutText from '../../../../assets/img/icloudWithoutText.png'

import './AgendasStep.scss'
import logo from '../../../../assets/img/logo.png'
import story from '../../../../assets/img/story.gif'
import ReactGA from 'react-ga'
import { requestSettings } from '../../../../store/settings/actions'
import { nextStep } from '../../../../store/onboarding/actions'
import { createCookie, readCookie } from '../../../../utils/cookies'
import { APP_URL, MS_CLIENT_ID } from '../../../../constants'
import { isValidEmail } from '../../../../utils/general'

class ButtonOffice extends React.Component {
  render() {
    return <img src={officeWithoutText} alt="Microsoft Office 365" />
  }
}

class ButtonExchange extends React.Component {
  render() {
    return <img src={exchangeLogo} alt="Microsoft Exchange" />
  }
}

class AgendasStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      icloud_selected: false,
      pick_agendas: false,
      agendas: [],
      selectedAgendas: [],
      minimumOneCalendar: false,
      error: '',
      isFetching: false,
      google_connected: false,
      exchange_connected: false,
      office_connected: false,
      icloud_connected: false,
      icloudEmail: '',
      icloudPassword: '',
    }

    const token = readCookie('token')
    if (token) {
      this.setState({
        isFetching: true,
      })
      this.props.requestSettings()
      this.setState({
        isFetching: false,
      })
    }

    ReactGA.event({
      category: 'Onboarding',
      action: 'Step 1',
    })
  }

  async addAgendas() {
    // if (agreed) {
    const obj = {
      agendas: this.state.selectedAgendas,
      agenda_type: this.state.agenda_type,
      agenda_email: this.state.agenda_email,
    }

    this.handleAddAgendasReceived(await postAddAgendas(obj))
    /* } else {
      this.setState({
        error: 'Please accept the terms and conditions before continuing.',
      })
    }
    */
  }

  async addGoogle(response) {
    const oneclick_info = {
      type: 'Google',
      token: decodeURIComponent(response.code),
      url: response.url,
    }
    this.setState({ isFetching: true })
    this.handleOneClickSignOnReceived(await oneClickSignon(oneclick_info))
  }

  async addOutlook(response) {
    this.setState({ isFetching: true })

    const outlook_info = {
      code: response.code,
    }
    
    console.log(outlook_info, 'outlook_info')

    this.handleOneClickSignOnReceived(await outlookAuth(response.code))
  }

  async authICloud(e) {
    const { icloudEmail, icloudPassword } = this.state
    if (icloudEmail !== '' && isValidEmail(icloudEmail) && icloudPassword !== '') {
      e.preventDefault()
      const icloud_info = {
        email: icloudEmail,
        password: icloudPassword,
      }
      this.setState({ isFetching: true })
      this.handleOneClickSignOnReceived(await iCloudAuth(icloud_info))
    }
    else {
      alert('Missing ad/or wrong data.')
    }
  }

  closeModal(e) {
    e.preventDefault()
    this.setState({
      icloud_selected: false,
      pick_agendas: false,
    })
  }

  closeModalWithoutE() {
    this.setState({
      icloud_selected: false,
      pick_agendas: false,
    })
  }

  failGoogle(/*response, error, details*/) {
    //console.log(error);
    //console.log(details);
  }

  handleAddAgendasReceived(response) {
    if (response.success) {
      this.closeModalWithoutE()
    } else {
      this.setState({
        error: 'Oops, something went wrong. Please try again.',
      })
    }
  }

  handleChange(agendaId, agendaName, event) {
    const isChecked = event.target.checked
    const agendas = this.state.selectedAgendas.slice()
    const agenda = {
      agenda_name: agendaName,
      agenda_id: agendaId,
    }

    if (isChecked) {
      agendas.push(agenda)
    } else {
      const index = agendas.map((e) => e.agenda_id).indexOf(agendaId)
      agendas.splice(index, 1)
    }

    this.setState({ selectedAgendas: agendas })
  }

  handleOneClickSignOnReceived(response) {
    if (!response.success) {
      this.setState({
        error: response.error,
        isFetching: false,
      })
    } else {
      this.closeModalWithoutE()
      this.setState({
        error: '',
        isFetching: false,
      })

      console.log(response.token, 'response.token')
      if (response.token) {
        createCookie('token', response.token, 60)
        console.log('createCookie')
        this.setState({
          minimumOneCalendar: true,
          icloud_selected: false,
          pick_agendas: false,
        })
        this.props.requestSettings()
        console.log('requestSettings')
      }

      if (response.id) {
        ReactGA.set({ userId: response.id })
      }

      console.log(response.agendas, 'response.agendas')
      if (response.agendas && response.agendas.length > 0) {
        console.log('setState')
        this.setState({
          icloud_selected: false,
          pick_agendas: true,
          agendas: response.agendas,
          agenda_type: response.agenda_application,
          agenda_email: response.agenda_email,
        })
      }
    }
  }

  handleShareCalendarClick(event) {
    event.preventDefault()
  }

  renderAgenda(agenda) {
    const isChecked =
      this.state.selectedAgendas.map((e) => e.agenda_id).indexOf(agenda.id) >
      -1
    return (
      <li key={agenda.id}>
        <label>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={this.handleChange.bind(this, agenda.id, agenda.name)}
          />
          {agenda.name}
        </label>
      </li>
    )
  }

  renderAgendas() {
    return (
      <ul className="renderAgendas">
        {this.state.agendas.map(this.renderAgenda, this)}
      </ul>
    )
  }

  renderCalendar(calendar) {
    let src

    switch (calendar.name) {
      case 'Google':
        src = googleWithoutText
        break
      case 'iCloud':
        src = icloudWithoutText
        break
      case 'Microsoft':
      case 'microsoft':
      case 'Office365':
        src = officeWithoutText
        break
      case 'Exchange':
        src = exchangeLogo
        break
      default:
        src = ''
    }

    return (
      <li className="is-connected-calendar" key={calendar.calendar_id}>
        <div>
          <img
            className="connectedCalendarLogo"
            src={src}
            alt={calendar.name}
          />
        </div>
        <div className="connectedCalendarName">
          <b>{calendar.email}</b>
          <span>
            {calendar.agendas
              .map(function(agenda) {
                return agenda.agenda_name
              })
              .join(', ')}
          </span>
        </div>
      </li>
    )
  }

  renderCalendars() {
    return (
      <ul className="connectedCalendars">
        {this.props.calendars.map(this.renderCalendar, this)}
      </ul>
    )
  }

  render() {
    const strings = this.props.strings
    let modal_content
    const error = (
      <p className="error">
        <div dangerouslySetInnerHTML={{ __html: this.state.error }} />
      </p>
    )

    if (this.state.icloud_selected) {
      modal_content = (
        <form onSubmit={this.authICloud.bind(this)}>
          <div className="has-text-centered">
            <img src={icloudWithoutText} alt="iCloud" />
          </div>
          {error}
          <div className="field">
            <label htmlFor="iCloudEmail">{strings.email}</label>
            <div className="control is-expanded">
              <input
                type="email"
                className="input is-fullwidth"
                placeholder="you@example.com"
                required
                onChange={(e) => this.setState({ icloudEmail: e.target.value })}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="iCloudPassword">{strings.password}</label>
            <div className="control is-expanded">
              <input
                type="password"
                className="input is-fullwidth"
                placeholder="********"
                required
                onChange={(e) => this.setState({ icloudPassword: e.target.value })}
              />
            </div>
          </div>
          <div className="field">
            <div className="control">
              <button className="button is-primary">
                {strings.add_calendar_button}
              </button>
            </div>
          </div>
        </form>
      )
    } else if (this.state.pick_agendas) {
      modal_content = (
        <div>
          <h3>{strings.agendas_explanation}</h3>
          {this.renderAgendas()}
          <button
            className="button is-primary morePadding"
            onClick={this.addAgendas.bind(this)}
          >
            {strings.select_agendas_button}
          </button>
          <div style={{ marginTop: '15px' }}>
            <input type="checkbox" data-lpignore="true" />
            <span style={{ marginLeft: '5px' }}>
              {strings.accept.text}
              <a href="/privacy" target="_blank">
                {strings.accept.link}
              </a>
              .
            </span>
          </div>
          {error}
        </div>
      )
    } else {
      modal_content = <div />
    }

    return (
      <div className="onboarding_box">
        <div className="onboarding_content agendasstep has-text-centered">
          <img className="logo" src={logo} alt="Plann3r" />

          <div>
            <img
              className="column is-8 is-centered-image what-is"
              src={story}
              alt="What is Plann3r?"
            />
          </div>

          {this.props.calendars.length > 0 && (
            <div>{this.renderCalendars()}</div>
          )}

          {this.props.calendars.length > 0 && (
            <div className="columns has-text-centered">
              <button
                className="is-rounded full-width"
                onClick={() => {
                  this.props.nextStep()
                }}
              >
                <div>{strings.get_started_button}</div>
                <span>
                  <i className="fa fa-angle-right" />
                </span>
              </button>
            </div>
          )}
          {this.state.isFetching && (
            <div>
              <Loading />
            </div>
          )}
          <div className="has-text-centered">
            <div className="step-description-string">{strings.description}</div>
            <div className="calendarButtonsList">
              <div className="columns">
                <button
                  className={
                    !this.state.google_connected
                      ? 'column is-6 calendarButtons'
                      : 'column is-6 calendarButtons is-connected'
                  }
                  onClick={() => {
                    document.getElementsByClassName('googleButton')[0].click()
                  }}
                >
                  <div className="calendarLogo">
                    <GoogleLogin
                      clientId="965664796606-1fatqjgr79ja662ior3hkfmu87u83m0g.apps.googleusercontent.com"
                      onSuccess={this.addGoogle.bind(this)}
                      onFailure={this.failGoogle.bind(this)}
                      scope="profile email https://www.google.com/calendar/feeds/"
                      responseType="code"
                      offline={true}
                      className="googleButtonOnboarding"
                      style={{}}
                    >
                      <span />
                    </GoogleLogin>
                  </div>
                  <div>
                    {!this.state.google_connected && (
                      <span>{strings.sign_in_google}</span>
                    )}
                    {this.state.google_connected && (
                      <span>
                        {strings.connected}
                        <i className="fa fa-check" />
                      </span>
                    )}
                  </div>
                </button>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  className={
                    !this.state.exchange_connected
                      ? 'column is-6 calendarButtons'
                      : 'column is-6 calendarButtons is-connected'
                  }
                  onClick={() => {
                    document
                      .getElementsByClassName('exchangeButton')[0]
                      .click()
                  }}
                >
                  <div className="calendarLogo">
                    <ReactLoginMS
                      clientId={MS_CLIENT_ID}
                      // required: 'application id/client id' obtained from https://apps.dev.microsoft.com for your app
                      redirectUri={APP_URL + '/outlook.html'} // required: redirectUri registered in https://apps.dev.microsoft.com for your app
                      scopes={[
                        'openid',
                        'https://outlook.office.com/calendars.readwrite',
                        'offline_access',
                      ]}
                      //optional: defaults to "user.read" full list is present
                      // https://developer.microsoft.com/en-us/graph/docs/concepts/permissions_reference
                      responseType="code" //optional: valid values are "token" for `Implicite OAuth flow` and "code" for `Authorization Code flow` defaults to "token"
                      cssClass="exchangeButton" // optional: space separated class names which are applied on the html Button element
                      btnContent={ButtonExchange}
                      // optional: can be string or a valid react component which can be rendered inside html Button element
                      handleLogin={this.addOutlook.bind(this)} // required: callback to receive token/code after successful login
                      style={{ backgroundImage: 'none' }}
                    />
                  </div>
                  <div>
                    {!this.state.exchange_connected && (
                      <span>{strings.sign_in_exchange}</span>
                    )}
                    {this.state.exchange_connected && (
                      <span>
                        {strings.connected}
                        <i className="fa fa-check" />
                      </span>
                    )}
                  </div>
                </a>
              </div>
              <div className="columns">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  className={
                    !this.state.office_connected
                      ? 'column is-6 calendarButtons'
                      : 'column is-6 calendarButtons is-connected'
                  }
                  onClick={() => {
                    document
                      .getElementsByClassName('office365Button')[0]
                      .click()
                  }}
                >
                  <div className="calendarLogo">
                    <ReactLoginMS
                      id="ms"
                      clientId={MS_CLIENT_ID}
                      // required: 'application id/client id' obtained from https://apps.dev.microsoft.com for your app
                      redirectUri={APP_URL + '/outlook.html'} // required: redirectUri registered in https://apps.dev.microsoft.com for your app
                      scopes={[
                        'openid',
                        'https://outlook.office.com/calendars.readwrite',
                        'offline_access',
                      ]}
                      //optional: defaults to "user.read" full list is present
                      // https://developer.microsoft.com/en-us/graph/docs/concepts/permissions_reference
                      responseType="code" //optional: valid values are "token" for `Implicite OAuth flow` and "code" for `Authorization Code flow` defaults to "token"
                      cssClass="office365Button" // optional: space separated class names which are applied on the html Button element
                      btnContent={ButtonOffice}
                      // optional: can be string or a valid react component which can be rendered inside html Button element
                      handleLogin={this.addOutlook.bind(this)} // required: callback to receive token/code after successful login
                    />
                  </div>
                  <div>
                    {!this.state.office_connected && (
                      <span>{strings.sign_in_office}</span>
                    )}
                    {this.state.office_connected && (
                      <span>
                        {strings.connected}
                        <i className="fa fa-check" />
                      </span>
                    )}
                  </div>
                </a>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  className={
                    !this.state.icloud_connected
                      ? 'column is-6 calendarButtons'
                      : 'column is-6 calendarButtons is-connected'
                  }
                  onClick={() => {
                    this.setState({ icloud_selected: true })
                  }}
                >
                  <div className="calendarLogo">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href="#"
                      onClick={() => {
                        this.setState({ icloud_selected: true })
                      }}
                    >
                      <img
                        className="bg-white"
                        src={icloudWithoutText}
                        alt="iCloud"
                      />
                    </a>
                  </div>
                  <div>
                    {!this.state.icloud_connected && (
                      <span>{strings.sign_in_icloud}</span>
                    )}
                    {this.state.icloud_connected && (
                      <span>
                        {strings.connected}
                        <i className="fa fa-check" />
                      </span>
                    )}
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div
            className={
              'modal' +
              (this.state.icloud_selected || this.state.pick_agendas
                ? ' is-active'
                : '')
            }
          >
            <div
              className="modal-background"
              onClick={this.closeModal.bind(this)}
              role="presentation"
            />
            <div className="modal-content">
              <div className="box">{modal_content}</div>
            </div>
            <button
              className="modal-close"
              onClick={this.closeModal.bind(this)}
            />
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    completed: state.onboarding.completed,
    calendars: state.settings.calendars,
    strings: state.languages.strings.onboarding.agendasstep,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    nextStep: () => dispatch(nextStep()),
    requestSettings: () => dispatch(requestSettings()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgendasStep)
